import React from "react";

export function preloadableLazy(importer) {
  let LoadedComponent = null;
  let pending = null;

  const preload = () => {
    if (!pending) {
      pending = importer().then((module) => {
        LoadedComponent = module.default;
        return module;
      }).catch((error) => {
        pending = null;
        throw error;
      });
    }
    return pending;
  };

  const LazyComponent = React.lazy(preload);
  function PreloadableComponent(props) {
    return LoadedComponent
      ? <LoadedComponent {...props} />
      : <LazyComponent {...props} />;
  }
  PreloadableComponent.preload = preload;
  return PreloadableComponent;
}
